import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import { useTranslation } from "react-i18next";

import { delta } from "@/lib/dashboard";
import { cn } from "@/lib/utils";

/**
 * Oldingi teng davrga nisbatan o'zgarish. `points` — foizning o'zi
 * solishtirilganda (bajarilish 62% → 70%) "+8 p." ko'rsatiladi, "+13%" emas.
 * `invert` — kamaygani yaxshi bo'lgan ko'rsatkich (bekor qilingan vazifa).
 */
export function DeltaBadge({
  current,
  previous,
  points = false,
  invert = false,
  className,
}: {
  current: number;
  previous: number;
  points?: boolean;
  invert?: boolean;
  className?: string;
}) {
  const { t } = useTranslation();
  const change = delta(current, previous);
  const good = change.trend === "flat" ? null : (change.trend === "up") !== invert;
  const Icon =
    change.trend === "up" ? ArrowUpRight : change.trend === "down" ? ArrowDownRight : Minus;

  let text: string;
  if (points) text = t("dashboard.deltaPoints", { value: Math.abs(change.diff) });
  else if (change.percent === null) text = change.diff === 0 ? "0" : t("dashboard.deltaNew");
  else text = `${Math.abs(change.percent)}%`;

  return (
    <span
      title={t("dashboard.deltaHint", { value: previous })}
      className={cn(
        "inline-flex h-5 items-center gap-0.5 rounded-full px-1.5 text-[11px] font-semibold tabular-nums",
        good === null && "bg-muted text-muted-foreground",
        good === true && "bg-success-soft text-success",
        good === false && "bg-destructive/10 text-destructive",
        className,
      )}
    >
      <Icon className="size-3" aria-hidden />
      {text}
    </span>
  );
}
